/* ============================================================
   Bomi365 — Landing page interactions
   ============================================================ */
   (() => {
    'use strict';
  
    const $ = (sel, ctx = document) => ctx.querySelector(sel);
    const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));
  
    /* -------------------- Purchase option toggle + live buybox -------------------- */
    const priceEl = $('[data-price]');
    const otPriceEl = $('[data-landing-ot-price]');
    const otMetaEl = $('[data-landing-ot-meta]');

    function landingFormatMoney(cents) {
      if (typeof formatMoney === 'function') return formatMoney(cents);
      const v = Number(cents) / 100;
      return '$' + (isFinite(v) ? v.toFixed(2) : '0.00');
    }

    let landingProduct = null;
    let landingCfg = null;

    function getLandingVariant() {
      if (!landingProduct || !landingCfg) return null;
      const id = Number(landingCfg.variantId);
      let v = landingProduct.variants.find(x => x.id === id);
      if (!v && landingProduct.selected_or_first_available_variant) {
        v = landingProduct.selected_or_first_available_variant;
      }
      return v || landingProduct.variants[0] || null;
    }

    function defaultSellingPlanId(variant) {
      const allocations = variant && variant.selling_plan_allocations ? variant.selling_plan_allocations : [];
      if (!allocations.length) return null;
      return allocations[0].selling_plan_id;
    }

    function checkedPurchaseRadio() {
      return $('input[name="po"]:checked');
    }

    function checkedPlanId() {
      const checked = checkedPurchaseRadio();
      if (!checked || checked.value === 'ot') return null;
      const raw = checked.getAttribute('data-plan-id');
      return raw ? Number(raw) : null;
    }

    function radioQty(radio) {
      if (!radio) return 1;
      const raw = radio.getAttribute('data-qty');
      const n = raw ? parseInt(raw, 10) : 1;
      return n > 0 ? n : 1;
    }

    function discountPctForPlan(planId) {
      if (!landingProduct || !landingProduct.selling_plan_groups || !landingProduct.selling_plan_groups[0]) return null;
      const plan = landingProduct.selling_plan_groups[0].selling_plans.find(p => p.id === planId);
      const adj = plan && plan.price_adjustments && plan.price_adjustments[0];
      if (!adj || adj.value_type !== 'percentage') return null;
      return adj.value;
    }

    function updateSubOption(radio, variant) {
      const opt = radio.closest('.purchase__opt');
      if (!opt) return;
      const planId = Number(radio.getAttribute('data-plan-id'));
      const qty = radioQty(radio);
      const alloc = (variant.selling_plan_allocations || []).find(a => a.selling_plan_id === planId);
      if (!alloc) return;

      const subPriceEl = opt.querySelector('[data-landing-sub-price], .js-sub-price');
      const subStrikeEl = opt.querySelector('[data-landing-sub-strike], .js-sub-strike');
      const titleEl = opt.querySelector('[data-landing-subscribe-title], .js-sub-title');

      const strikeCentsPerUnit = alloc.compare_at_price && alloc.compare_at_price > alloc.price
        ? alloc.compare_at_price
        : variant.price;

      if (subPriceEl) subPriceEl.textContent = landingFormatMoney(alloc.price * qty);
      if (subStrikeEl) subStrikeEl.textContent = landingFormatMoney(strikeCentsPerUnit * qty);

      const pct = discountPctForPlan(planId);
      if (titleEl) titleEl.textContent = pct != null ? 'Subscribe & Save ' + pct + '%' : 'Subscribe & Save';
    }

    function updateLandingPricesFromProduct() {
      const variant = getLandingVariant();
      if (!variant) return;

      const onetimeCents = variant.price;

      if (otPriceEl) otPriceEl.textContent = landingFormatMoney(onetimeCents);
      if (otMetaEl) otMetaEl.textContent = 'Free shipping';

      $$('input[name="po"][data-plan-id]').forEach(radio => updateSubOption(radio, variant));

      const checked = checkedPurchaseRadio();
      const mode = checked ? checked.value : 'ot';
      const planId = checkedPlanId();
      const qty = radioQty(checked);
      const alloc = planId != null ? (variant.selling_plan_allocations || []).find(a => a.selling_plan_id === planId) : null;
      const subCents = alloc ? alloc.price * qty : null;

      if (priceEl) {
        priceEl.textContent = mode !== 'ot' && subCents != null ? landingFormatMoney(subCents) : landingFormatMoney(onetimeCents);
      }

      const stickyStrong = document.querySelector('[data-landing-sticky-price]');
      const stickySuf = document.querySelector('[data-landing-sticky-suffix]');
      if (stickyStrong && stickySuf) {
        if (mode !== 'ot' && subCents != null) {
          stickyStrong.textContent = landingFormatMoney(subCents);
          stickySuf.textContent = (checked.getAttribute('data-freq-label') || '/mo') + ' · Subscribe';
        } else {
          stickyStrong.textContent = landingFormatMoney(onetimeCents);
          stickySuf.textContent = ' · One-time';
        }
      }
    }

    $$('input[name="po"]').forEach(r => {
      r.addEventListener('change', () => {
        $$('.purchase__opt').forEach(o => o.classList.remove('purchase__opt--active'));
        const lab = r.closest('.purchase__opt');
        if (lab) lab.classList.add('purchase__opt--active');
        if (landingProduct) updateLandingPricesFromProduct();
      });
    });

    function initLandingBuybox() {
      const cfgEl = document.getElementById('landing-buybox-config');
      if (!cfgEl || !window.routes || !window.routes.cart_add_url) return;
      try {
        landingCfg = JSON.parse(cfgEl.textContent.trim());
      } catch (e) {
        console.error('Landing buybox: bad config JSON', e);
        return;
      }
      if (!landingCfg.productUrl) return;
      fetch(landingCfg.productUrl)
        .then(res => res.json())
        .then(data => {
          landingProduct = data;
          updateLandingPricesFromProduct();
        })
        .catch(e => console.error('Landing buybox: product fetch failed (prices may be stale)', e));
    }

    function landingCartAddSucceeded(r, data) {
      if (!r || !r.ok || !data || typeof data !== 'object') return false;
      if (typeof data.status === 'number' && data.status >= 400) return false;
      if (data.errors && Object.keys(data.errors).length) return false;
      const n = data.item_count;
      const items = data.items;
      return (Array.isArray(items) && items.length > 0) || (typeof n === 'number' && n > 0);
    }

    async function postCartAddJson(addUrl, item) {
      return fetch(addUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ items: [item] })
      });
    }

    async function postCartAddForm(addUrl, variantId, planId, quantity) {
      const fd = new FormData();
      fd.append('id', String(variantId));
      fd.append('quantity', String(quantity || 1));
      if (planId) fd.append('selling_plan', String(planId));
      const headers = { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' };
      return fetch(addUrl, { method: 'POST', headers, body: fd });
    }

    async function addLandingLine() {
      if (!window.routes || !window.routes.cart_add_url) {
        alert(window.cartStrings?.error || 'Cart is unavailable.');
        return;
      }
      if (!landingCfg) {
        document.getElementById('offer')?.scrollIntoView({ behavior: 'smooth' });
        alert('Product is not configured for this page. Set the Sticky bar product in theme settings.');
        return;
      }
      const variant = landingProduct ? getLandingVariant() : null;
      const variantId = variant ? variant.id : landingCfg.variantId;
      if (!variantId) {
        alert(window.cartStrings?.error || 'Missing product variant.');
        return;
      }

      const checkedRadio = checkedPurchaseRadio();
      const wantSub = checkedRadio ? checkedRadio.value !== 'ot' : false;
      let planId = null;
      if (wantSub) {
        const raw = checkedRadio.getAttribute('data-plan-id');
        planId = raw ? Number(raw) : null;
        if (!planId) planId = variant ? defaultSellingPlanId(variant) : null;
        if (!planId && landingCfg.defaultSellingPlanId) planId = landingCfg.defaultSellingPlanId;
      }
      const quantity = wantSub ? radioQty(checkedRadio) : 1;

      const baseAdd = window.routes.cart_add_url;
      const addUrl = baseAdd.endsWith('.js') ? baseAdd : `${baseAdd}.js`;
      const item = { id: Number(variantId), quantity: quantity };
      if (planId) item.selling_plan = Number(planId);

      const btns = $$('[data-landing-add-to-cart]');
      btns.forEach(b => { b.setAttribute('aria-busy', 'true'); b.disabled = true; });

      const checkoutTarget =
        (window.routes.checkout_url && String(window.routes.checkout_url).trim()) || '/checkout';

      try {
        let r = await postCartAddJson(addUrl, item);
        let data = await r.json().catch(() => null);

        if (!landingCartAddSucceeded(r, data)) {
          r = await postCartAddForm(addUrl, variantId, planId, quantity);
          data = await r.json().catch(() => null);
        }

        if (!landingCartAddSucceeded(r, data)) {
          const safe = data && typeof data === 'object' ? data : {};
          let desc = safe.description;
          if (Array.isArray(desc)) desc = desc.join(', ');
          const msg = (desc && String(desc)) || safe.message || window.cartStrings?.error || 'Cart error';
          console.error('Landing buybox: cart add failed', r.status, safe);
          alert(msg);
          btns.forEach(b => { b.disabled = false; b.removeAttribute('aria-busy'); });
          return;
        }

        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer) {
          try {
            const sectionsResp = await fetch('/cart?sections=cart-drawer,cart-icon-bubble');
            const sectionsData = await sectionsResp.json();
            btns.forEach(b => { b.disabled = false; b.removeAttribute('aria-busy'); });
            cartDrawer.renderContents({ id: Number(variantId), sections: sectionsData });
          } catch (drawerErr) {
            console.error('Landing: could not open cart drawer', drawerErr);
            window.location.assign(checkoutTarget);
          }
        } else {
          window.location.assign(checkoutTarget);
        }
      } catch (e) {
        console.error(e);
        alert(window.cartStrings?.error || 'Could not add to cart');
        btns.forEach(b => { b.disabled = false; b.removeAttribute('aria-busy'); });
      }
    }

    initLandingBuybox();

    $$('[data-landing-add-to-cart]').forEach(btn => {
      btn.addEventListener('click', () => { addLandingLine(); });
    });

    /* sync hidden .cart-count-bubble → visible .header__cart-badge */
    (function syncCartBadge() {
      const cartIcon = document.getElementById('cart-icon-bubble');
      if (!cartIcon) return;
      const bubble = cartIcon.querySelector('.cart-count-bubble');
      const badge  = cartIcon.querySelector('.header__cart-badge');
      if (!bubble || !badge) return;
      function update() {
        const span = bubble.querySelector('span[aria-hidden="true"]');
        const n = span ? parseInt(span.textContent.trim(), 10) || 0 : 0;
        if (n > 0) badge.textContent = n;
        badge.style.display = n > 0 ? '' : 'none';
      }
      new MutationObserver(update).observe(bubble, { childList: true, subtree: true, characterData: true });
    })();

    /* -------------------- Clinical results before/after toggle -------------------- */
    const resultsMedia = $('[data-results-media]');
    const resultsFrames = $$('[data-results-frame]');
    const resultsToggles = $$('[data-results-toggle]');

    resultsToggles.forEach(btn => {
      btn.addEventListener('click', () => {
        if (!resultsMedia) return;

        const mode = btn.dataset.resultsToggle;
        resultsMedia.classList.toggle('is-after', mode === 'after');

        resultsFrames.forEach(frame => {
          frame.setAttribute('aria-hidden', frame.dataset.resultsFrame === mode ? 'false' : 'true');
        });

        resultsToggles.forEach(toggle => {
          const isActive = toggle === btn;
          toggle.classList.toggle('is-active', isActive);
          toggle.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });
      });
    });
  
    /* -------------------- Sticky mobile CTA bar -------------------- */
    const stickybar = $('#stickybar');
    const heroSection = $('.hero');
    if (stickybar && heroSection && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver(([entry]) => {
        const beyondHero = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        stickybar.classList.toggle('is-visible', beyondHero);
        stickybar.setAttribute('aria-hidden', beyondHero ? 'false' : 'true');
      }, { threshold: 0, rootMargin: '0px 0px -20% 0px' });
      io.observe(heroSection);
    }
  
    /* -------------------- Lazy decode hero image -------------------- */
    // Already handled with native loading="lazy" on below-the-fold.
  
    /* -------------------- Exit-intent popups -------------------- */
    const STORAGE_KEYS = {
      giveaway: 'bomi.exit.giveaway.until',
      onefive: 'bomi.exit.onefive.until',
      sessionShown: 'bomi.exit.sessionShown'
    };
    const COOLDOWN = {
      giveaway: 24 * 60 * 60 * 1000,        // 24h
      onefive: 7 * 24 * 60 * 60 * 1000      // 7d
    };
  
    const popups = {
      giveaway: $('#popup-giveaway'),
      onefive: $('#popup-onefive')
    };
  
    function isOnCooldown(key) {
      const ts = parseInt(localStorage.getItem(STORAGE_KEYS[key]) || '0', 10);
      return Date.now() < ts;
    }
    function setCooldown(key) {
      localStorage.setItem(STORAGE_KEYS[key], String(Date.now() + COOLDOWN[key]));
    }
  
    let lastFocused = null;
    function openPopup(key) {
      const el = popups[key];
      if (!el) return;
      if (sessionStorage.getItem(STORAGE_KEYS.sessionShown)) return;
      if (isOnCooldown(key)) return;
      Object.values(popups).forEach(p => p && p.classList.remove('is-open'));
      lastFocused = document.activeElement;
      el.classList.add('is-open');
      el.setAttribute('aria-hidden', 'false');
      sessionStorage.setItem(STORAGE_KEYS.sessionShown, '1');
      document.body.style.overflow = 'hidden';
      // Focus trap entry: focus the close button so Esc/Enter work immediately
      const close = $('.popup__close', el);
      if (close) setTimeout(() => close.focus(), 30);
    }
    function closePopup(el) {
      if (!el) return;
      el.classList.remove('is-open', 'is-success');
      el.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
      // Apply cooldown so they aren't re-shown next session
      if (el.id === 'popup-giveaway') setCooldown('giveaway');
      if (el.id === 'popup-onefive') setCooldown('onefive');
    }
  
    // Wire close buttons + overlay
    $$('[data-popup-close]').forEach(btn => {
      btn.addEventListener('click', e => {
        const root = e.target.closest('.popup');
        closePopup(root);
      });
    });
  
    // Esc to close
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape') {
        const open = $('.popup.is-open');
        if (open) closePopup(open);
      }
    });
  
    // Focus trap inside open popup
    document.addEventListener('keydown', e => {
      if (e.key !== 'Tab') return;
      const open = $('.popup.is-open');
      if (!open) return;
      const focusable = $$(
        'a[href], button, input, select, textarea, [tabindex]:not([tabindex="-1"])',
        open
      ).filter(n => !n.hasAttribute('disabled') && n.offsetParent !== null);
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  
    // Form submission (replace with real provider on Shopify)
    $$('[data-popup-form]').forEach(form => {
      form.addEventListener('submit', e => {
        e.preventDefault();
        const root = form.closest('.popup');
        const email = form.querySelector('input[type="email"]').value.trim();
        if (!email) return;
  
        // Build a "thanks" panel without rebuilding the popup
        let thanks = root.querySelector('.popup__thanks');
        if (!thanks) {
          thanks = document.createElement('div');
          thanks.className = 'popup__thanks';
          thanks.innerHTML = `
            <h4>You're in.</h4>
            <p>We'll email <strong>${email.replace(/[<>]/g, '')}</strong> if you win or qualify. In the meantime, enjoy 10% off your first order with code <strong>CELL10</strong>.</p>
            <button type="button" class="btn btn--primary" data-popup-close>Continue Shopping</button>
          `;
          root.querySelector('.popup__body').appendChild(thanks);
          thanks.querySelector('[data-popup-close]').addEventListener('click', () => closePopup(root));
        }
        root.classList.add('is-success');
        // Email submit hook — connect to Klaviyo / ESP here.
      });
    });
  
    /* -------- Triggers: desktop mouseleave + mobile scroll-up + idle -------- */
    function pickPopup() {
      // Alternate based on visit count for rough A/B
      const visits = parseInt(localStorage.getItem('bomi.visits') || '0', 10) + 1;
      localStorage.setItem('bomi.visits', String(visits));
      return visits % 2 === 0 ? 'onefive' : 'giveaway';
    }
  
    let armed = true;
    function fire() {
      if (!armed) return;
      if (sessionStorage.getItem(STORAGE_KEYS.sessionShown)) return;
      const candidate = pickPopup();
      if (!isOnCooldown(candidate)) {
        openPopup(candidate);
        armed = false;
        return;
      }
      // fallback to the other one
      const other = candidate === 'giveaway' ? 'onefive' : 'giveaway';
      if (!isOnCooldown(other)) {
        openPopup(other);
        armed = false;
      }
    }
  
    // Desktop: mouse leaving toward top of viewport
    document.addEventListener('mouseout', e => {
      if (e.relatedTarget || e.toElement) return;
      if (e.clientY > 0) return;
      fire();
    });
  
    // Mobile: rapid scroll-up after some downward scroll
    let lastY = window.scrollY;
    let downScroll = 0;
    let lastDir = 0;
    let upBurst = 0;
    window.addEventListener('scroll', () => {
      const y = window.scrollY;
      const dy = y - lastY;
      if (dy > 0) downScroll += dy;
      if (dy < -8) {
        if (lastDir >= 0) upBurst = 0;
        upBurst += -dy;
        if (downScroll > 600 && upBurst > 280 && y < window.innerHeight * 0.5) fire();
      }
      lastDir = dy;
      lastY = y;
    }, { passive: true });
  
    // Idle/back-button feel: long idle on desktop also triggers
    let idle;
    function resetIdle() {
      clearTimeout(idle);
      idle = setTimeout(() => {
        if (window.scrollY > 600 && !document.hidden) fire();
      }, 45_000);
    }
    ['mousemove','scroll','keydown','touchstart'].forEach(ev => window.addEventListener(ev, resetIdle, { passive: true }));
    resetIdle();
  
    /* -------------------- Smooth scroll offset for sticky header -------------------- */
    // CSS handles smooth scroll via html{scroll-behavior:smooth}.
    // Add scroll-padding-top so anchored sections aren't hidden by sticky header.
    document.documentElement.style.scrollPaddingTop = '90px';

    /* -------------------- #offer CTAs scroll exactly to the heading, no offset -------------------- */
    // Only for the product-landing page (sections/offer-section.liquid), which renders
    // two copies of the heading (mobile/desktop) with the inactive one hidden via
    // display:none. Other landing pages (landing.liquid / landing2.liquid) don't have
    // these ids and keep their existing plain anchor-scroll behavior untouched.
    function findOfferHeading() {
      const ids = ['offer-h-desktop', 'offer-h-mobile'];
      const candidates = ids.map(id => document.getElementById(id)).filter(Boolean);
      if (!candidates.length) return null;
      return candidates.find(el => el.offsetParent !== null) || candidates[0];
    }
    function scrollToOfferHeading() {
      const target = findOfferHeading();
      if (!target) return;
      const top = target.getBoundingClientRect().top + window.pageYOffset;
      window.scrollTo({ top, behavior: 'smooth' });
    }
    $$('a[href="#offer"], a[href="#offer-h"]').forEach(link => {
      link.addEventListener('click', (e) => {
        if (!findOfferHeading()) return;
        e.preventDefault();
        scrollToOfferHeading();
        history.replaceState(null, '', '#offer');
      });
    });

    /* -------------------- Mobile nav -------------------- */
    const burger = $('.header__burger');
    const mobileNav = $('#mobile-nav');
    const mobileOverlay = $('#mobile-nav-overlay');

    function openMobileNav() {
      burger.classList.add('is-open');
      burger.setAttribute('aria-expanded', 'true');
      mobileNav.classList.add('is-open');
      mobileNav.setAttribute('aria-hidden', 'false');
      mobileOverlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }

    function closeMobileNav() {
      burger.classList.remove('is-open');
      burger.setAttribute('aria-expanded', 'false');
      mobileNav.classList.remove('is-open');
      mobileNav.setAttribute('aria-hidden', 'true');
      mobileOverlay.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    if (burger) {
      burger.addEventListener('click', () => {
        burger.classList.contains('is-open') ? closeMobileNav() : openMobileNav();
      });
    }
    if (mobileOverlay) mobileOverlay.addEventListener('click', closeMobileNav);
    $$('.mobile-nav__link, .mobile-nav__cta').forEach(el => el.addEventListener('click', closeMobileNav));

    /* -------------------- Footer accordion (mobile only) -------------------- */
    $$('.footer__menu-heading').forEach(btn => {
      btn.addEventListener('click', () => {
        if (window.innerWidth >= 768) return;
        const expanded = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!expanded));
      });
    });
  })();
  